export const MAX_PROMPT_CHARS = 200;

const SUSPICIOUS_PROMPT_PATTERNS = [
  /;\s*(drop|delete|truncate|alter|update|insert|create)\b/i,
  /\b(drop\s+table|truncate\s+table|delete\s+from|alter\s+table|insert\s+into|update\s+\w+\s+set)\b/i,
  /--/,
  /\/\*/,
  /\*\//,
  /\bunion\s+select\b/i,
  /\bor\s+1\s*=\s*1\b/i,
  /\bexec\s*\(/i,
  /\beval\s*\(/i,
  /<script\b/i,
];

// This intentionally catches only obvious code-like input. Backend validation
// remains authoritative for security and request validation.
export const hasSuspiciousPromptPattern = (prompt) =>
  SUSPICIOUS_PROMPT_PATTERNS.some((pattern) => pattern.test(prompt));

export const validatePromptInput = (prompt) => {
  const value = typeof prompt === "string" ? prompt : "";
  const trimmed = value.trim();

  if (!trimmed) {
    return {
      valid: false,
      code: "EMPTY_PROMPT",
      message: "Please enter an IDP population data question.",
    };
  }

  if (value.length > MAX_PROMPT_CHARS) {
    return {
      valid: false,
      code: "PROMPT_TOO_LONG",
      message:
        "Your question is too long. Please shorten it and provide a country and year context.",
    };
  }

  if (hasSuspiciousPromptPattern(value)) {
    return {
      valid: false,
      code: "UNSAFE_PROMPT_PATTERN",
      message:
        "This prompt contains unsupported characters patterns. Please enter an IDP population data question.",
    };
  }

  return {
    valid: true,
    code: "OK",
    message: "",
  };
};
